import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import CssBaseline from '@mui/material/CssBaseline';
import Container from '@mui/material/Container';
import AppRouter from './AppRouter';
// import { useLocation } from 'react-router-dom';
import { makeStyles } from '@mui/styles';
import StepperForm from '../../pages/stepper-form/index';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
  },
  main: {
    position: 'absolute',
    marginTop: '-40vh',
  },
  footer: {
    padding: theme.spacing(1, 2),
    marginTop: 'auto',

    backgroundColor:
      theme.palette.type === 'light'
        ? theme.palette.grey[200]
        : theme.palette.grey[800],
  },
}));

export default function AppLayout() {
  // const location = useLocation();
  // const classes = useStyles();

  return (
    <React.Fragment>
      {/* <CssBaseline /> */}
      {/* <AppBar> */}
      <Toolbar>
        <Typography variant="h6" component="div">
          Material Multi-Step Form With Formik & Yup
        </Typography>
      </Toolbar>
      {/* </AppBar> */}
      <Toolbar />
      <Container>
        {/* <AppRouter /> */}
        <StepperForm />
      </Container>
    </React.Fragment>
  );
}
